<template>
  <div id="permissions">
    <MazSpinner :size="100" />
    <!--<div
    <div
      class="confirm-identity"
      v-if="!identityConfirmed && member"
    >
      <div class="identity-modal">
        <div class="logo">
          <img
            src="@/assets/logo.svg"
            alt=""
          >
          <p>MAESTRO</p>
        </div>
        <div class="header">
          <h3>Choose an account</h3>
        </div>
        <div
          class="active-member"
          @click="confirmIdentity"
        >
          <div class="avatar">
            <img
              src="@/assets/default-avatar.svg"
              alt=""
            >
          </div>
          <p class="title">{{ member.title }}</p>
          <p class="email">{{ member.email }}</p>
        </div>
        <div class="actions">
          <button
            class="secondary-button big"
            @click="changeUser"
          >Use another account</button>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import { PandaService } from '../utils/request'
import { MazSpinner } from 'maz-ui'
const jwtDecode = require('jwt-decode')

export default {
  name: 'Permissions',
  data () {
    return {
      member: null,
      applicationId: this.$route.query.applicationId,
      scopes: this.$route.query.scopes,
      redirectUri: this.$route.query.redirectUri,
      organizationId: this.$route.query.organizationId,
      state: this.$route.query.state
    }
  },
  computed: {
    ...mapState([
      'identityConfirmed'
    ])
  },
  async beforeMount () {
    if (!this.identityConfirmed) {
      await this.getMember()
      if (this.$route.query.email !== this.member.email) {
        this.redirectToAuthentication()
      } else {
        this.confirmIdentity()
      }
    } else {
      this.createAuthorizationCode()
    }
  },
  watch: {
    'identityConfirmed' () {
      this.createAuthorizationCode()
    }
  },
  methods: {
    async createAuthorizationCode () {
      const params = {}
      params['applicationId'] = this.applicationId
      params['scopes'] = this.scopes
      if (this.redirectUri) {
        params['redirectUri'] = this.redirectUri
      }
      if (this.state) {
        params['state'] = this.state
      }
      const { status, data } = await PandaService({
        url: 'authorizationcodes',
        method: 'CREATE',
        params
      })
      if (status === 200) {
        let decoded = jwtDecode(data.authorizationCode)
        let url = new URL(decoded.location)
        url.searchParams.set('code', data.authorizationCode)
        if (this.redirectUri) {
          url.searchParams.set('redirectUri', this.redirectUri)
        }
        if (this.organizationId) {
          url.searchParams.set('organizationId', this.organizationId)
        }
        window.location.assign(url.href)
      }
    },
    async getMember () {
      const { data, status } = await PandaService({
        url: 'members/me',
        method: 'GET'
      })
      if (status === 200) {
        this.member = data
      }
    },
    changeUser () {
      this.redirectToAuthentication()
    },
    ...mapMutations([
      'confirmIdentity'
    ]),
    ...mapActions([
      'redirectToAuthentication'
    ])
  },
  components: {
    MazSpinner
  }
}
</script>
